export default __webpack_public_path__ + "static/media/logo.a38b4bf8.png";